@if (bookmark) {
  <p-confirmDialog
    key="bookmarkGuestLinkDeleteDialog"
    #cd
    styleClass="w-9"
    appendTo="body"
    [blockScroll]="false">
    <ng-template pTemplate="headless" let-message>
      <div class="p-card border-round pt-1 p-4">
        <app-header
          icon="fas fa-trash"
          [text]="
            'Gast-Link zur Ansicht „' + bookmark.title + '“ wirklich löschen?'
          "></app-header>

        @if (!bookmark.published) {
          Beim Löschen des Gast-links, können die Ansichten nicht mehr über
          alte, bereits weitergeleitete Links, aufgerufen werden.
        } @else {
          <app-alert [canToggle]="false" styleClass="p-3">
            <i class="fas fa-circle-info"></i>
            "{{ bookmark.title }} ist veröffentlicht und muss nicht über einen
            Gast-Link zur Verfügung gestellt werden."
          </app-alert>
        }

        <p-divider></p-divider>
        <div class="flex align-items-center gap-3 mt-4">
          <button
            [rounded]="true"
            [outlined]="true"
            severity="secondary"
            pButton
            icon="fas fa-times"
            label="nein, abbrechen"
            (click)="cd.reject()"></button>
          <button
            [rounded]="true"
            pButton
            [severity]="'danger'"
            icon="fas fa-check"
            label="ja, löschen"
            (click)="cd.accept()"
            class="ml-auto"></button>
        </div>
      </div>
    </ng-template>
  </p-confirmDialog>
}
